import { render, staticRenderFns } from "./ResourceCenterLayout.vue?vue&type=template&id=46db8c0f&scoped=true"
import script from "./ResourceCenterLayout.vue?vue&type=script&lang=js"
export * from "./ResourceCenterLayout.vue?vue&type=script&lang=js"
import style0 from "./ResourceCenterLayout.vue?vue&type=style&index=0&id=46db8c0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46db8c0f",
  null
  
)

export default component.exports